import React from "react";
import { Dropdown, Menu } from "antd";
import "./EllipsisMenu.scss";
import ellipsis from "../../assets/Images/ellipsis.svg";

const EllipsisMenu = ({ options = [] }) => {
  const renderLabel = (option) => (
    <span className="menu-item-content">
      {option.icon && <span className="menu-icon">{option.icon}</span>}
      <span className="ellipsis-options">{option.label}</span>
    </span>
  );

  /* An option carrying `children` becomes a submenu, so an action with a few
     variants (export ranges, for instance) can be picked in one gesture
     instead of opening a dialog. */
  const menu = (
    <Menu className="actionMenuWrapper">
      {options.map((option, idx) =>
        option.children?.length ? (
          <Menu.SubMenu
            key={idx}
            className={option.highlight ? "active" : ""}
            popupClassName="actionMenuWrapper actionSubMenuWrapper"
            title={renderLabel(option)}
          >
            {option.children.map((child, childIdx) => (
              <Menu.Item
                key={`${idx}-${childIdx}`}
                onClick={child.onClick}
                className={child.divided ? "has-divider" : ""}
              >
                <span className="menu-item-content">
                  <span className="ellipsis-options">{child.label}</span>
                </span>
              </Menu.Item>
            ))}
          </Menu.SubMenu>
        ) : (
          <Menu.Item
            key={idx}
            onClick={option.onClick}
            className={option.highlight ? "active" : ""}
          >
            {renderLabel(option)}
          </Menu.Item>
        ),
      )}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      <img
        src={ellipsis}
        alt="menu"
        className="ellipsis-icon"
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default EllipsisMenu;
